import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.CorteVentaDTO;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Fecha desde", cell: x => ({ data: kea.formatDate(x.FechaDesde) }) },
    { title: "Fecha corte", cell: x => ({ data: kea.formatDate(x.FechaCorte) }) },
];

export interface BotonesDeps {
    onConsultarComisiones: (item: Entity) => void;
}

function botones(deps: BotonesDeps): kea.Grid2Column<Entity, undefined> {
    return kea.columnaBotones<Entity>([
        {
            tooltip: "Consultar comisiones",
            style: "primary",
            iconClass: fa("file-excel-o"),
            onClick: deps.onConsultarComisiones
        }
    ]);
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps): kea.Grid2Column<Entity, undefined>[] {
    return [botones(deps), ...columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/corteventas/list/columns.tsx